import type {
  ISuspenseAccountSetting,
  ISuspenseAccountSettingFilter,
  ISuspenseAccountSettingInput,
} from "@models/master-data/suspenseAccountSettingModel"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import suspenseAccountSettingService from "@services/master-data/accountingData/suspenseAccountSettingService"
import { makeAutoObservable } from "mobx"

/** Feature-0369 — state màn cấu hình tài khoản treo. */
class SuspenseAccountSettingStore {
  isLoading = false
  tableData: PagedResultDto<ISuspenseAccountSetting> = {
    items: [],
    totalCount: 0,
  }
  /** `null` = chế độ TẠO MỚI (modal tự set default `isActive`); khác `null` = đang sửa dòng đã có. */
  detailData: ISuspenseAccountSetting | null = null

  constructor() {
    makeAutoObservable(this)
  }

  async getAll(params: ISuspenseAccountSettingFilter) {
    this.isLoading = true
    try {
      this.tableData = await suspenseAccountSettingService.getAll(params)
    } finally {
      this.isLoading = false
    }
  }

  async get(id: number) {
    this.isLoading = true
    try {
      this.detailData = await suspenseAccountSettingService.get(id)
      return this.detailData
    } finally {
      this.isLoading = false
    }
  }

  async createOrUpdate(body: ISuspenseAccountSettingInput) {
    this.isLoading = true
    try {
      this.detailData = await suspenseAccountSettingService.createOrUpdate(body)
      return this.detailData
    } finally {
      this.isLoading = false
    }
  }

  async delete(id: number) {
    this.isLoading = true
    try {
      await suspenseAccountSettingService.delete(id)
    } finally {
      this.isLoading = false
    }
  }

  initDetail() {
    this.detailData = null
  }
}

export default SuspenseAccountSettingStore
